module.exports = __webpack_public_path__ + "img/icon3.ddf2afb0.png";